<template>
  <div v-if="!hasUser && product">
    <h3 class="text-center width-expand">
      {{ translateUcFirst("justopp.user.actionRequiresLoginTitle") }}
    </h3>
    <div class="flex-start margin-2xl-top">
      <div class="flex flex-middle flex-center width-expand gap-l">
        <form-button
          icon="arrow-login-inline-end"
          text="login"
          @click="redirectToLogin()"></form-button>
        <span>OR</span>
        <form-button
          icon="user"
          text="Sign Up"
          @click="redirectToRegister()"></form-button>
      </div>
    </div>
  </div>
  <div v-if="product && !product.AuctionProductType">
    <h3>Error: this product is not sellable via a bidding process.</h3>
  </div>
  <div v-if="hasUser && product && product.AuctionProductType && product.JustoppDealProductType">
    <div class="flex-between flex-stretch flex-column m:flex-row gap-l">
      <div class="actions width-expand" style="min-height: 300px">
        <div>
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.product") }}:</strong
          ><span>{{ product.name }}</span
          ><br />
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.brand") }}:</strong
          ><span>{{ product.brandName }}</span
          ><br />
          <br />
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.code") }}:</strong
          ><span>{{ product.code }}</span
          ><br />
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.deliveryMethod") }}:</strong
          >
          <span>{{
            translate(
              "justopp.justoppDealProductType.deliveryMethod" +
                product.JustoppDealProductType.deliveryMethod
            )
          }}</span>
          <br />
          <strong style="width: 175px; display: inline-block">{{ translateUcFirst("justopp.bid.originWarehouseCountry") }}:</strong
          >
          <span v-if="product.JustoppDealProductType.warehouseCountry">{{
              product.JustoppDealProductType.warehouseCountry !== ""
                ? product.JustoppDealProductType.warehouseCountry
                : "-"
            }}</span>
          <span v-else="">{{
              product.JustoppDealProductType.originWarehouse !== ""
                ? product.JustoppDealProductType.originWarehouse
                : "-"
            }}</span>
          <br />
          <br />
          <!--
         <strong style="width: 175px; display: inline-block"
           >{{ translateUcFirst("justopp.bid.startingBid") }}:</strong
         >

         <span>{{
           translateNumber(product.AuctionProductType.startingPrice, "currency", {
             currency: product.currency,
           })
         }} / {{translate('justopp.deal.unit')}}</span>
         <br />-->
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.minimumBid") }}:</strong
          >
          <span
            >{{
              translateNumber(minimumBid, "currency", { currency: product.currency })
            }}
            / {{ translate("justopp.deal.unit") }}</span
          >
          <br />
          <strong style="width: 175px; display: inline-block"
            >{{ translateUcFirst("justopp.bid.availableUnits") }}:</strong
          >
          <span
            >{{ translateNumber(product.JustoppDealProductType.maximumQuantity) }}
          </span>
          <br />
        </div>
        <!--
        product name<br>
        product brand<br>
        starting bid<br>
        current bid<br>
        -->
        <div class="bid-ui margin-l-vertical margin-auto-horizontal max-width-500">

          <div class="flex gap-m flex-center flex-top flex-break-center">
            <form-input
              v-model="quantity"
              class="quantity-controls max-width-200 "
              style="width: 100%; flex: 100%;"
              type="justoppUnits"
              label="justopp.deal.selectQuantity"
              :step-size="product?.JustoppDealProductType?.minimumQuantity"
              :minimum="product?.JustoppDealProductType?.minimumQuantity"
              :maximum="
                        product?.JustoppDealProductType?.maximumQuantity
                      "></form-input>
            <div class="bid-input flex flex-bottom flex-center margin-s-bottom max-width-200">
              <form-input
                label="justopp.deal.selectBidAmount"
                v-model="bidAmount"
                :loading="asyncStatus.loading"
                :disabled="asyncStatus.loading"
                :error-message="inputErrorMessage"
                @focus="isBidAmountFocused = true"
                @blur="isBidAmountFocused = false"
                class="amount-control"
                type="price"></form-input>
              <form-input
                v-model="currency"
                :disabled="true"
                style="
                max-width: 80px !important;
                min-width: 0;
                padding-inline: 0;
                text-align: center;
              "
                class="currency-controls"
                type="text"></form-input>
            </div>
          </div>

          <div class="width-expand text-center">
            <strong style="display: inline-block">
              {{ translateUcFirst("justopp.bid.minimumBid") }}
            </strong>
            <span>: &nbsp;</span>
            <strong
              >{{
                translateNumber(minimumBid, "currency", { currency: product.currency })
              }}
              / {{ translate("justopp.deal.unit") }}</strong
            >
          </div>
          <div class="cta-button">
            <form-button
              v-if="bidAmount !== product.price"
              class="width-expand margin-l-top"
              icon="check"
              theme="lead"
              :loading="asyncStatus.loading"
              :disabled="asyncStatus.loading"
              @click="startBidPlaceByState"
            >{{ translate("justopp.bid.placeBidCta") }}</form-button >
            <form-button
              v-if="bidAmount === product.price"
              class="width-expand margin-l-top"
              icon="cart-plus"
              theme="success"
              :loading="asyncStatus.loading"
              :disabled="asyncStatus.loading"
              @click="startBidBuyNowByState"
            >{{ translate("justopp.bid.buyNow") }}</form-button >
          </div>

          <span class="text-center block margin-s-top">
            {{ translateUcFirst('justopp.bid.totalPrice') }}:
             {{
              translateNumber(quantity * bidAmount, "currency", {
                currency: product?.currency,
              })
            }} ({{translate('justopp.bid.countUnits',{count:quantity})}})
          </span>
        </div>

        <icon-text
          v-if="bidAmount !== product.price"
          icon="warning-triangle" class="c-danger">
          <span class="c-inverse">
            {{ translateUcFirst("justopp.bid.tosNotification") }}
            <a href="#">{{ translateUcFirst("justopp.bid.tos") }}</a
            >.
          </span>
        </icon-text>
        <icon-text
          v-if="bidAmount === product.price"
          icon="check" class="c-success">
          <span class="c-inverse">
            {{ translateUcFirst("justopp.bid.buyNowExplain") }}
          </span>
        </icon-text>
      </div>
      <div class="product-media width-expand">
        <div class="product-image" style="width: 100%; height: 300px">
          <img class="contain-image" :src="product.introImage" alt="product.name" />
        </div>
        <div class="brand-information flex-center flex-middle gap-m margin-l-top">
          <div class="brand-logo">
            <img class="contain-image" :src="product.brandLogo" alt="product.name" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useCarts from "@/client/extensions/composition/useCarts";


export default {
  props: {
    product: {
      type: [Object, Boolean],
      default: false,
    },
  },
  emits: ["bid-placer:bid-placed", "bid-placer:bid-failed"],
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    let carts = useCarts(props);

    return { asyncOps, asyncOpsReady, asyncStatus, carts };
  },
  data: function () {
    return {
      isBidAmountFocused: false,
      lastBidAmountInput: false,
      bidAmount: 0,
      quantity: 50,
      currency: "",
      inputErrorMessage: "",
    };
  },
  computed: {
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    hasUser() {
      return this.userProfile?.id;
    },
    highestCurrentBid() {
      let bids = this.product.AuctionProductType.AuctionBids;
      let min = 0;

      bids.forEach((bid) => {
        if (bid.amount > min) {
          min = bid.amount;
        }
      });

      return min;
    },
    minimumBid() {
      let min = this.product.AuctionProductType.startingPrice;
      if (this.highestCurrentBid > min) {
        min = this.highestCurrentBid + config.justopp.auction.minBidIncrease;
      }

      return min;
    },
  },
  watch: {
    bidAmount(newVal) {
      this.lastBidAmountInput = newVal;
     // this.bidAmountChangeHandler(newVal)
      if ( !this.isBidAmountFocused) {
        this.bidAmountChangeHandler(newVal);
      }
    },
    isBidAmountFocused(isFocused) {
      if ( !isFocused) {
        this.bidAmountChangeHandler(this.lastBidAmountInput);
      }
    },
    product: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.bidAmount = this.minimumBid;
            this.currency = this.product.currency;
            this.quantity = this.product.JustoppDealProductType.maximumQuantity;
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    setTimeout(() => {
      //console.log("product", this.product);
    }, 500);
  },
  methods: {
    async startBidBuyNowByState() {
      let cart = await this.carts.getCart();
      await cart.empty();
      let itemToAdd = {
        ProductId: this.product.id,
        quantity: this.quantity,
        productConfig: {
          justoppDeal: {},
        },
      };
      let addResult = await cart.addItem(itemToAdd);
      this.$router.push({ name: "store-checkout", params: { locale: this.locale } });

    },
    bidAmountChangeHandler(newVal) {
      this.inputErrorMessage = "";
      if (Number(newVal) > Number(this.product.price)) {
        this.bidAmount = Number(this.product.price);
      }

      if (Number(newVal) < Number(this.minimumBid)) {
        this.bidAmount = Number(this.minimumBid);
      }
    },
    redirectToRegister() {
      let redirectArg = this.$router.resolve({
        name: "store-deals-dealId",
        params: { dealId: this.product.id },
      });

      this.$router.push({
        name: "user-register",
        query: { redirectUrl: redirectArg.fullPath },
      });
    },
    redirectToLogin() {
      let redirectArg = this.$router.resolve({
        name: "store-deals-dealId",
        params: { dealId: this.product.id },
      });

      this.$router.push({
        name: "user-login",
        query: { redirectUrl: redirectArg.fullPath },
      });
    },
    async startBidPlaceByState() {
      this.bidAmountChangeHandler(this.bidAmount);

      let confirmed = false;

      this.$s.ui.modal
        .confirm("justopp.bid.bidConfirmText", "justopp.bid.bidConfirmTitle")
        .then(() => {
          this.createBidByState();
        })
        .catch((e) => {});
    },
    async createBidByState() {
      this.inputErrorMessage = "";

      if (this.bidAmount < this.minimumBid) {
        this.inputErrorMessage = this.translateUcFirst(
          "justopp.bid.bidTooLowValidationError"
        );
        return true;
      }

      let data = {
        amount: this.bidAmount,
        quantity: this.quantity,
        userId: this.$store.getters["user/profile"]?.id,
        AuctionProductTypeId: this.product.AuctionProductType.id,
      };

      const url = `justopp/auction/${this.product.AuctionProductType.id}/bid`;

      let result = await this.asyncOps.asyncCall(url, data, { method: "post" });

      if (result.isError && result.code !== 422) {
        this.inputErrorMessage = this.translate("justopp.bid.createErrors.exception");
        return false;
      }

      if (result.isError && result.code == 422) {
        let errors = [];
        Object.values(result.data).forEach((errorArray) => {
          let errString = errorArray.map((msg) => this.translate(msg)).join(", ");
          errors.push(errString);
        });

        this.inputErrorMessage = errors.join(", ");
        return false;
      }

      this.$emit("bid-placer:bid-placed", { result });
      this.$s.ui.notification("justopp.bid.bidPlacedSuccessNotification", "success");
    },
  },
};
</script>

<style scoped lang="scss">
.product-image {
  overflow: hidden;
  border-radius: var(--border-radius-s);
  border: 1px solid var(--c-gray-2);
  background: var(--c-gray-1);
}

.brand-logo {
  height: 70px;
}
</style>
